var map = {
	"./README.md": [
		5829,
		1,
		829
	],
	"./api/client-lists/GET": [
		2637,
		9,
		637
	],
	"./api/client-lists/GET.ts": [
		2637,
		9,
		637
	],
	"./api/client-lists/POST": [
		8691,
		9,
		691
	],
	"./api/client-lists/POST.ts": [
		8691,
		9,
		691
	],
	"./api/client-lists/_clientListId/files/PUT": [
		3480,
		9,
		480
	],
	"./api/client-lists/_clientListId/files/PUT.ts": [
		3480,
		9,
		480
	],
	"./api/client-lists/_clientListId/files/_fileId/GET": [
		7436,
		9,
		436
	],
	"./api/client-lists/_clientListId/files/_fileId/GET.ts": [
		7436,
		9,
		436
	],
	"./api/client-lists/list/GET": [
		1598,
		9,
		598
	],
	"./api/client-lists/list/GET.ts": [
		1598,
		9,
		598
	],
	"./api/users/me/GET": [
		617,
		9,
		617
	],
	"./api/users/me/GET.ts": [
		617,
		9,
		617
	],
	"./mock-routes": [
		4805,
		9
	],
	"./mock-routes.ts": [
		4805,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5256;
module.exports = webpackAsyncContext;